import { render, staticRenderFns } from "./EmailGroupMgmt.vue?vue&type=template&id=124b8ee0&"
import script from "./EmailGroupMgmt.vue?vue&type=script&lang=js&"
export * from "./EmailGroupMgmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports